import adityaBirla from '@images/insurer_page/adityabirla.png'
import digit from '@images/insurer_page/digit.png'

// Import icons
import ambulance from "@icons/ambulance.svg"
import doc from '@icons/doc.svg'
import board from "@icons/board.svg"
import ayush from "@icons/ayush.svg"
import human from '@icons/employee.svg'
import roomRent from '@icons/room-rent.svg'
import covid from "@icons/covid.svg"
import tests from '@icons/tests.svg'
import daycare from "@icons/daycare.svg"
import hospital from "@icons/hospital.svg"
import hrd from "@icons/hrd.svg"
import microscope from "@icons/microscope.svg"
import sthetoscope from "@icons/sthetoscope.svg"
import foreign from "@icons/foreign.svg"
import maternity from "@icons/maternity.svg"
import infertility from "@icons/infertility.svg"
import eye from "@icons/eye.svg"
import eCard from "@icons/e-card.svg"
import money from "@icons/money.svg"

// Constants => IDs of insurers as per document IDs in firebase backend
export const adityaBirlaId = "IP-uz4aspfddfdf"
export const digitId = "IP-uz4aspfddfdg"

export interface Insurer{
    id:string,
    benefitsCovered:InsurerBenefits,
    benefitsExcluded: InsurerBenefits,
    addons:InsurerBenefits,
    details:InsurerDetails
}

export interface InsurerDetails{
    name: string,
    description: string,
    provider:string,
    logoSrc:string
}

export enum InsuranceType{
    Monthly="INS"
}

export interface Quantity{
    imgSrc: string,
    name: string,
    description: string,
    value?:string|number
}

export interface InsurerBenefits{
    [key : string]: Quantity,
}

export const loopBenefitsCovered:InsurerBenefits = {
    claims: {
        imgSrc: money,
        name: "24*7 claims support",
        description: "Comprehensive support on Claims Settlement at your service",
    },
    eCard: {
        imgSrc: eCard,
        name: "Easy E-Card Access",
        description: "Quickly access your E-Card anytime through the Loop App",
    },
    consult: {
        imgSrc: doc,
        name: "Unlimited Doctor Consultations",
        description: "Covering the cost of Pre-Hospitalisation procedures for upto 30 Days and Post- Hospitalisation for upto 60 Days",
    },
    tests: {
        imgSrc:tests,
        name: "Book Lab Tests",
        description: "Exclusive discounts on booking lab tests and medicines through the Loop App",
    },
    hrd: {
        imgSrc: hrd,
        name: "HR Dashboard",
        description: "A cummulative HR Dashboard to keep track of your employee premiums and policies",
    },
}

// Insurance Providers
export const adityaBirlaInsurance: Insurer = {
    id:adityaBirlaId,
    details: {
        name: 'Aditya Birla Plan',
        description: "Covers all the basic needs, Easy on pocket",
        provider:"Aditya Birla Health Insurance",
        logoSrc:adityaBirla
    },
    benefitsCovered: {
        roomRent: {
            imgSrc: roomRent,
            name: "Room Rent",
            description: "Covered upto 2% (of SI Insured) for a normal room and 4% (of SI) for ICU",
            value:"₹6,000/Day (Normal Room) ₹12,000/Day (ICU)"
        },
        ambulance: {
            imgSrc: ambulance,
            name: "Ambulance",
            description: "Covering charges upto ₹2,500 in cases of emergency",
            value:"Upto ₹2500"
        },
        daycareTreatment:  {
            imgSrc: daycare,
            name: "Day Care Treatment",
            description: "Procedures that require less than 24 hours of hospitalisation",
            value:"527 procedures covered"
        },
        prepostHosp:  {
            imgSrc: sthetoscope,
            name: "Pre Post Hospitalization",
            description: "Covering the cost of Pre-Hospitalisation procedures for upto 30 Days and Post- Hospitalisation for upto 60 Days",
            value:"Covered upto 30 Days and 60 Days"
        },
        ayushTreatment: {
            imgSrc: ayush,
            name: "Ayush Treatment",
            description: "Covered upto ₹50,000 for Ayurvedic, Yoga, Unani, Siddha, and Homeopathy Treatment ",
            value: "Covered upto ₹1.5 Lacs on IPD",
        },
        modernTreatment: {
            imgSrc: microscope,
            name: "Modern Treatment",
            description: "Covered upto 50% of Sum Insured on IPD basis for complex procedures like oral chemotherapy, Immunotherapy, Intra vitreal injections, bronchical thermoplasty, cochlear implant, uterine artery embolization, etc ",
            value: "Covered upto 50% of Sum Insured",
        }
    },
    addons: {
        hospitalization: {
            imgSrc: hospital,
            name: "Hospitalization",
            description: "Expenses upto Sum Insured when hospitalised for 24 hours or more",
            value: "Expenses upto Sum Insured when hospitalised for 24 hours or more",
        },
        preExistingDiseases: {
            imgSrc: human,
            name: "Pre Existing Diseases",
            description: "Expenses upto Sum Insured when hospitalised for 24 hours or more",
            value: "Covered",
        },
        ultraModernTreatment: {
            imgSrc: sthetoscope,
            name: "Ultra Modern Treatment",
            description: "Covered upto 50% of Sum Insured on IPD basis for complex procedures like oral chemotherapy, Immunotherapy, Intra vitreal injections, bronchical thermoplasty, cochlear implant, uterine artery embolization, etc ",
            value: "Covered upto 50% of Sum Insured on IPD basis for complex procedures like oral chemotherapy, Immunotherapy, Intra vitreal injections, bronchical thermoplasty, cochlear implant, uterine artery embolization, etc ",
        },
        domiciliaryHospitalisation: {
            imgSrc: human,
            name: "Domiciliary Hospitalisation",
            description: "Hospitalisaion at Home due to unavailability of hospitals or condition of the patient",
            value: "Covered as defined in GHI Policy wordings",
        },
    },
    benefitsExcluded: {
        maternity: {
            imgSrc: maternity,
            name: "Maternity",
            description: "Expenses upto Sum Insured when hospitalised for 24 hours or more",
            value:"Expenses upto sum insured"
        },
        lasik: {
            imgSrc: eye,
            name: "Lasik Surgery",
            description: "Covering charges upto ₹2,500 in cases of emergency",
            value:"Upto ₹2500"
        },
        infertility:  {
            imgSrc: infertility,
            name: "Infertility",
            description: "Procesdures associated with Infertility such as IVF and Surrogacy",
            value:"Not covered"
        },
        foreignTreatment:  {
            imgSrc: foreign,
            name: "Foreign Treatments",
            description: "Procedures that require less than 24 hours of hospitalisation",
            value:"Covered upto 30 Days and 60 Days"
        },
    }
}
export const digitInsurance: Insurer = {
    id:digitId,
    details: {
        name: 'Go Digit Plan',
        description: "Added benefits for premium health experience",
        provider:"Digit Insurance",
        logoSrc:digit
    },
    benefitsCovered: {
        roomRent: {
            imgSrc: roomRent,
            name: "Room Rent",
            description: "Covered upto 2% (of SI Insured) for a normal room and 4% (of SI) for ICU",
            value:"₹6,000/Day (Normal Room) ₹12,000/Day (ICU)"
        },
        ambulance: {
            imgSrc: ambulance,
            name: "Ambulance",
            description: "Covering charges upto ₹2,500 in cases of emergency",
            value: "Upto ₹1000",
        },
        daycareTreatment:  {
            imgSrc: daycare,
            name: "Day Care Treatment",
            description: "Procedures that require less than 24 hours of hospitalisation",
            value:"Covered"
        },
        prepostHosp:  {
            imgSrc: sthetoscope,
            name: "Pre-Post Hospitalization",
            description: "The rent paid for a hospital",
            value:"Covered upto 30 Days and 60 Days"
        },
        covidTreatment: {
            imgSrc: covid,
            name: "Covid Treatment",
            description: "Covered upto ₹50,000 for Ayurvedic, Yoga, Unani, Siddha, and Homeopathy Treatment ",
            value: "Covered",
        },
        namedAliments: {
            imgSrc: money,
            name: "Named Aliments",
            description: "Covered upto 50% of Sum Insured on IPD basis for complex procedures like oral chemotherapy, Immunotherapy, Intra vitreal injections, bronchical thermoplasty, cochlear implant, uterine artery embolization, etc ",
            value: "Covered",

        }
    },
    addons: {
        hospitalization: {
            imgSrc: hospital,
            name: "Hospitalization",
            description: "Expenses upto Sum Insured when hospitalised for 24 hours or more",
            value: "Expenses upto Sum Insured when hospitalised for 24 hours or more",
        },
        preExistingDiseases: {
            imgSrc: board,
            name: "Modern Treatment",
            description: "Expenses upto Sum Insured when hospitalised for 24 hours or more",
            value: "Covered",
        },
        ultraModernTreatment: {
            imgSrc: microscope,
            name: "Ultra Modern Treatment",
            description: "Covered upto 50% of Sum Insured on IPD basis for complex procedures like oral chemotherapy, Immunotherapy, Intra vitreal injections, bronchical thermoplasty, cochlear implant, uterine artery embolization, etc ",
            value: "Covered upto 50% of Sum Insured on IPD basis for complex procedures like oral chemotherapy, Immunotherapy, Intra vitreal injections, bronchical thermoplasty, cochlear implant, uterine artery embolization, etc ",
        },
        domiciliaryHospitalisation: {
            imgSrc: money,
            name: "Domiciliary Hospitalisation",
            description: "Hospitalisaion at Home due to unavailability of hospitals or condition of the patient",
            value: "Covered as defined in GHI Policy wordings",
        },
    },
    benefitsExcluded: {
        maternity: {
            imgSrc: maternity,
            name: "Maternity",
            description: "Expenses upto Sum Insured when hospitalised for 24 hours or more",
            value:"Expenses upto sum insured"
        },
        lasik: {
            imgSrc: eye,
            name: "Lasik Surgery",
            description: "Covering charges upto ₹2,500 in cases of emergency",
            value:"Upto ₹2500"
        },
        infertility:  {
            imgSrc: infertility,
            name: "Infertility",
            description: "Procesdures associated with Infertility such as IVF and Surrogacy",
            value:"Not covered"
        },
        foreignTreatment:  {
            imgSrc: foreign,
            name: "Foreign Treatments",
            description: "Procedures that require less than 24 hours of hospitalisation",
            value:"Covered upto 30 Days and 60 Days"
        },
    },
}
